export { default as default } from './modules/PhoneInputNativeDefaultMetadata'
export { default as PhoneInput } from './modules/PhoneInput'
export { default as formatPhoneNumber } from './modules/formatPhoneNumberDefaultMetadata'
export { default as isValidPhoneNumber } from './modules/isValidPhoneNumberDefaultMetadata'


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-phone-number-input/index.js
// module id = 73
// module chunks = 0